var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoPrinter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 18") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-774.000000, -1073.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18",
    transform: "translate(775.000000, 1074.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "printer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "doc",
    transform: "translate(21.000000, 9.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 1,
    cy: 1,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(9.000000, 17.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.309570312,0.852050781 L8.38427734,0.852050781",
    id: "Path-80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.309570312,4.85205078 L5.38427734,4.85205078",
    id: "Path-80"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M3,14 L24,14",
    id: "Path-81",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    points: "5 17.8520508 0.00415039062 17.8520508 0.00415039062 5.04614258 25.9584961 5.04614258 25.9584961 17.8520508 22 17.8520508"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    points: "6.00415039 5.04614258 6.00415039 0.0461425781 20.9584961 0.0461425781 20.9584961 5.04614258"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-87",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    points: "5.92163086 14 5.92163086 25.8352051 21 25.8352051 21 14"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPrinter);
export default __webpack_public_path__ + "static/media/ico_printer.f3514079638cb3b4d9a895e838b9cea3.svg";
export { ForwardRef as ReactComponent };